import { render } from "./HeaderSideBar.vue?vue&type=template&id=476271ff&ts=true"
import script from "./HeaderSideBar.vue?vue&type=script&lang=ts"
export * from "./HeaderSideBar.vue?vue&type=script&lang=ts"

import "./HeaderSideBar.vue?vue&type=style&index=0&id=476271ff&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__